import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { stopEventRefs } from "../subjects/stopEvent/refs";

/**
 * What the unit left the stop carrying.
 */
export const DepartureLoadStateSchema = z.enum(["loaded", "empty"]).openapi("DepartureLoadState");

export type DepartureLoadState = z.infer<typeof DepartureLoadStateSchema>;

/**
 * The driver departed a stop.
 */
export const departureV1 = tmsEventKind(
  { category: "movement", kind: "departure", version: 1 },
  {
    refs: stopEventRefs,
    facts: {
      stopName: z.string(),
      /** Present on loaded departures only. */
      city: z.string().nullable(),
      /** Null when the vendor's task says nothing about what the unit left with. */
      loadState: DepartureLoadStateSchema.nullable(),
    },
  },
);

export const DepartureV1Schema = departureV1.schema;
export const DepartureV1FactsSchema = departureV1.facts;

export type DepartureV1 = z.infer<typeof DepartureV1Schema>;
export type DepartureV1Facts = z.infer<typeof DepartureV1FactsSchema>;

/** Every version of `departure`, keyed by version. What `catalog.ts` places under `movement`. */
export const departure = { 1: departureV1 } as const;
